const MegaMenu = () => {
    
    // Do not run this script if the current page is a campaign page with the menu disabled
    if (document.body.classList.contains('category-reports') && !document.body.classList.contains('enable-menu')) {
        return;
    }

    const siteHeader = document.querySelector('body .site-header');
    if (!siteHeader) return;
    
    const menuItems = siteHeader.querySelectorAll('.main-navigation ul li');

    let isHovering = false; // Tracks if any item is being hovered
    let closeTimeout;
    let currentlyOpenMenu = null; // Track the currently open mega menu

    // Function to open the mega menu for the current item
    const openMegaMenu = (item, megamenu) => {
        clearTimeout(closeTimeout); // Clear any pending close action
        isHovering = true; // We're now hovering over a menu item
        siteHeader.setAttribute('data-light-header', 'true');

        // Close the previously open mega menu, if any
        if (currentlyOpenMenu && currentlyOpenMenu !== megamenu) {
            currentlyOpenMenu.classList.remove('open');
        }

        item.classList.add('hovered');
        megamenu.classList.add('open');
        currentlyOpenMenu = megamenu; // Set this as the currently open mega menu
    };

    // Function to close the mega menu for the current item
    const closeMegaMenu = (item, megamenu) => {
        closeTimeout = setTimeout(() => {
            if (!isHovering) { // Only close if no hover is detected after the delay
                siteHeader.removeAttribute('data-light-header');
                item.classList.remove('hovered');
                megamenu.classList.remove('open');
                currentlyOpenMenu = null; // Clear the currently open mega menu
            }
        }, 500); // Delay to prevent flickering when quickly moving between the elements
    };

    // Add event listeners to each menu item
    menuItems.forEach((item) => {
        const megamenu = item.querySelector('.mega-menu-content');
        if (!megamenu) return;

        // Event listener when entering a menu item
        item.addEventListener('mouseenter', () => {
            openMegaMenu(item, megamenu);
        });

        // Event listener when leaving a menu item
        item.addEventListener('mouseleave', () => {
            isHovering = false; // Tentatively assume no hover after leaving the item
            closeMegaMenu(item, megamenu);
        });

        // Add event listeners for the mega menu itself
        megamenu.addEventListener('mouseenter', () => {
            isHovering = true; // Keep hovering status active when inside the mega menu
            clearTimeout(closeTimeout); // Clear any pending close action
        });

        megamenu.addEventListener('mouseleave', () => {
            isHovering = false; // Tentatively assume no hover after leaving the mega menu
            closeMegaMenu(item, megamenu);
        });
    });
};

export default MegaMenu;